export enum ConfirmationBoxTypeEnum {
    Danger = 'Danger',
    Info = 'Info',
    Success = 'Success',
    Warning = 'Warning'
}
